import { useState } from "react";
import AddWorkflow from "../../components/workflows/AddWorkflow";
import RemoveWorkflow from "../../components/workflows/RemoveWorkflow";
import WorkOrderWorkflow from "../../components/workflows/WorkOrderWorkflow";
import DeliveryWorkflow from "../../components/workflows/DeliveryWorkflow";
import EditWorkflow from "../../components/workflows/EditWorkflow";
import styles from "./HomePage.module.css";

const WORKFLOWS = [
  { id: "add",       label: "Add",                  icon: "+",  color: "green" },
  { id: "remove",    label: "Remove",               icon: "−",  color: "red" },
  { id: "workOrder", label: "Pharmacy Work Order",   icon: "📋", color: "blue" },
  { id: "delivery",  label: "Delivery",             icon: "📦", color: "purple" },
  { id: "edit",      label: "Edit",                 icon: "✏",  color: "orange" },
];

export default function HomePage({ products, user, onTransaction, onNewProduct, onUpdateProduct }) {
  const [active, setActive] = useState(null);

  if (active === "add") {
    return <AddWorkflow products={products} user={user} onTransaction={onTransaction} onNewProduct={onNewProduct} onBack={() => setActive(null)} />;
  }
  if (active === "remove") {
    return <RemoveWorkflow products={products} user={user} onTransaction={onTransaction} onBack={() => setActive(null)} />;
  }
  if (active === "workOrder") {
    return <WorkOrderWorkflow products={products} user={user} onTransaction={onTransaction} onBack={() => setActive(null)} />;
  }
  if (active === "delivery") {
    return <DeliveryWorkflow products={products} user={user} onTransaction={onTransaction} onBack={() => setActive(null)} />;
  }
  if (active === "edit") {
    return <EditWorkflow products={products} user={user} onUpdateProduct={onUpdateProduct} onTransaction={onTransaction} onBack={() => setActive(null)} />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>Select Workflow</div>
      <div className={styles.grid}>
        {WORKFLOWS.map(w => (
          <button key={w.id} onClick={() => setActive(w.id)}
            className={`${styles.workflowBtn} ${styles[w.color]}`}>
            <div className={styles.workflowIcon}>{w.icon}</div>
            <div className={styles.workflowLabel}>{w.label}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
